import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { ConfigService } from './app/services/config.service';
import { LocalStorageUtil } from './app/utils/local-storage.util';

/**
 * Bootstrap do app sem carregar config na inicialização.
 * A config é carregada após a autenticação (rota /oauth) ou em background
 * quando já existe token no localStorage (ex.: refresh na aplicação).
 */
bootstrapApplication(App, appConfig)
  .then((appRef) => {
    const configService = appRef.injector.get(ConfigService);
    if (LocalStorageUtil.hasAuthenticatedSession()) {
      // Usuário já autenticado (ex.: refresh) — carrega config em background
      configService.loadConfig().subscribe({
        next: () => {
          if (configService.isDebugEnabled()) {
            console.log('✅ [main.ts] Configuração carregada (usuário já autenticado).');
          }
        },
        error: (err) => {
          if (configService.isDebugEnabled()) {
            console.warn('⚠️ [main.ts] Config em background falhou:', err?.message);
          }
        },
      });
    }
  })
  .catch((err) => {
    console.error('❌ [main.ts] Falha no bootstrap:', err);
  });
